<template>
  <div>
      <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-3/12 mb-4 mr-4">
          <cep :number="address.cep" @fetching="(val) => addressCtrlEnabled = !val" @fetched="(val) => completeAddressFields(val)" :disabled="disabled"/>
      </div>

      <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4">
          <vs-input v-validate.initial="{required : true}" name="LOGRADOURO" class="w-full"  icon-no-border label="LOGRADOURO" v-model="address.logradouro" :disabled="disabled"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('LOGRADOURO')">{{ errors.first('LOGRADOURO') }}</span>
      </div>

      <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-2/12 mb-4">
          <vs-input name="NÚMERO" class="w-full" icon-no-border label="NÚMERO" v-model="address.numero" :disabled="disabled"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('NÚMERO')">{{ errors.first('NÚMERO') }}</span>
      </div>

      <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4">
          <vs-input v-validate.initial="{required : true}" name="BAIRRO" class="w-full" icon-no-border label="BAIRRO" v-model="address.bairro" :disabled="disabled"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('BAIRRO')">{{ errors.first('BAIRRO') }}</span>
      </div>

      <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4">
          <vs-input v-validate.initial="{ required: true }" name="MUNICIPIO" class="w-full" icon-no-border label="MUNICIPIO" v-model="address.municipio" :disabled="disabled"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('MUNICIPIO')">{{ errors.first('MUNICIPIO') }}</span>
      </div>

      <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-4/12 mb-4">
          <label class="ml-1">Estado</label>
          <estate-province :selected="address.uf" @change="(val) => address.uf = val" :disabled="disabled"/>
      </div>
  </div>
</template>

<script>
  import Estate from '@/components/shared/States';
  import EstateProvince from '@/components/shared/SelectEstate'
  import Cep from '@/components/shared/Cep'

  export default {
    components: {
      EstateProvince,
      Cep
    },
    data() {
      return {
        addressCtrlEnabled : true,
      }
    },
    props: {
      value: {
        type: Object,
        required: true
      },
      disabled: Boolean
    },
    computed: {
      address: {
        get () {
          return this.value;
        },
        set (v) {
          this.$emit('input', v);
        }
      }
    },
    methods: {
      completeAddressFields (fields) {
          this.$set(this.address, 'cep', fields.data.cep)
          this.$set(this.address, 'logradouro', fields.data.logradouro)
          this.$set(this.address, 'bairro', fields.data.bairro)
          this.$set(this.address, 'municipio', fields.data.localidade)
          this.$set(this.address, 'uf', fields.data.uf)
          this.$set(this.address, 'codMunicipio', fields.data.ibge)
          this.$set(this.address, 'cUf', Estate.getCUFByCode(fields.data.uf))
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>